var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"queries-list-item-list"},_vm._l((_vm.resolvedQueries),function(query,index){return _c('queriesListItem',{key:`list-query-${index}`,attrs:{"query":query}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }